"use strict";
'use es6'; // IMPORTANT: These are ordered by priority, ex. if a user owns both starter and
// pro contacts, the starter parcels are ignored

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MARKETING_CONTACTS_QUANTITIES = exports.CONTACTS_QUANTITIES = void 0;
var CONTACTS_QUANTITIES = {
  'additional-contacts-and-emails': 1000,
  'additional-contacts-and-emails-5x': 1000
};
exports.CONTACTS_QUANTITIES = CONTACTS_QUANTITIES;
var MARKETING_CONTACTS_QUANTITIES = {
  'additional-marketing-contacts-starter': 1000,
  'additional-marketing-contacts-pro': 5000,
  'additional-marketing-contacts-enterprise': 10000
};
exports.MARKETING_CONTACTS_QUANTITIES = MARKETING_CONTACTS_QUANTITIES;